import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import defaultLayout from './default.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

type LayoutKey = 'default';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const LAYOUTS: Record<LayoutKey, unknown> = {
    default: defaultLayout
};

const route = useRoute();

const metaLayout = computed(() => {
    return route.meta?.layout as LayoutKey || undefined;
});

const layoutComponent = computed(() => {
    return LAYOUTS[metaLayout.value] || LAYOUTS.default;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value)))
}
}

})